import {fontStyles, theme} from '@styles/theme';
import styled from 'styled-components';
import {TextProps} from '@atoms/Text';

export const Headline = styled.span<TextProps>`
  ${fontStyles.headline}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const TitleR = styled.span<TextProps>`
  ${fontStyles.titleR}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const SubtitleR = styled.span<TextProps>`
  ${fontStyles.subtitleR}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const CaptionB = styled.span<TextProps>`
  ${fontStyles.captionB}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const BodyNum = styled.span<TextProps>`
  ${fontStyles.bodyNum}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const BodyM = styled.span<TextProps>`
  ${fontStyles.bodyM}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const BodyR = styled.span<TextProps>`
  ${fontStyles.bodyR}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const TinyNum = styled.span<TextProps>`
  ${fontStyles.tinyNum}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const TinyM = styled.span<TextProps>`
  ${fontStyles.tinyM}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;

export const TinyR = styled.span<TextProps>`
  ${fontStyles.tinyR}
  color: ${({color}: TextProps) => (color ? `${color}` : `${theme.colors.basic00}`)};
  text-align: ${({align}: TextProps) => (align ? `${align}` : 'left')};
  display: ${({display}: TextProps) => (display ? `${display}` : 'block')};
`;
